<template>
  <v-card>
    <v-snackbar v-model="snackbar" bottom :color="snackbarColor">
      {{ snackbarText }}
      <v-btn dark text @click="snackbar = false">x</v-btn>
    </v-snackbar>
    <v-card-title class="headline grey lighten-2">Mis últimas llamadas</v-card-title>
    <v-card-text>
      <v-simple-table height="500px" fixed-header>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Número</th>
              <th class="text-left">Hora nro.</th>
              <th class="text-left">Hora llamado</th>
              <th class="text-left">Observaciones</th>
              <th class="text-left">Hora turno</th>
              <th class="text-left">Profesional</th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in numerosRecepcionLlamados" :key="index">
              <td
                :class="{'display-1':!item.showPatient, 'title':item.showPatient}"
              >{{ item.numeroDisplay }}</td>
              <td>{{ item.horaNumero }}</td>
              <td>{{ item.horaLlamado }}</td>
              <td>{{ item.observaciones }}</td>
              <td>{{ item.horaTurno }}</td>
              <td>{{ item.servicio }}</td>
              <td>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="calling || !connected()"
                      icon
                      color="orange"
                      @click="callNro(item)"
                      v-on="on"
                    >
                      <v-icon>mdi-bell-ring-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Llamar de nuevo</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="closeFn()">cerrar</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('Numeros', ['numerosRecepcionLlamados']),
    ...mapState('InitConfig', ['puestoActual'])
  },
  props: {
    closeFn: Function,
    connected: Function
  },
  data () {
    return {
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      calling: false
    }
  },
  methods: {
    ...mapActions('Numeros', ['fetchNumerosRecepcionLlamados']),
    ...mapActions('Llamadas', ['llamarNumero']),
    getNumerosRecepcionLlamados () {
      var vm = this
      return vm.fetchNumerosRecepcionLlamados({
        puestoId: vm.puestoActual.id
      })
    },
    callNro (nro) {
      var vm = this
      var llamada = {
        quien: nro.numeroDisplay,
        puestoId: vm.puestoActual.id,
        numId: nro.id,
        yaLlamado: true
      }
      vm.calling = true
      vm.llamarNumero(llamada)
        .then(() => {
          vm.getNumerosRecepcionLlamados()
          vm.snackbarText = `Llamando a ${llamada.quien}`
          vm.snackbar = true
          vm.snackbarColor = 'success'
          vm.calling = false
        })
        .catch(data => {
          vm.snackbarText = data.error[0]
          vm.snackbar = true
          vm.snackbarColor = 'error'
          vm.calling = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
